import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getUserPermissions } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchUserPermissions(): Promise<TResult> {
  const response = await fetch(getUserPermissions, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<string>;
  IsSuccess: boolean;
  StatusCode: number;
};

function useGetUserPermissions(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_user_permissions',
    async () => {
      const fetchResponse = await fetchUserPermissions();
      return fetchResponse;
    },
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetUserPermissions };
